import { roleHasDealershipCapability } from "../models/dealershipCapabilities.js";
import { ViewModel } from "../mvvm/ViewModel.js";
/** Business summary, sales/expenses, and investors (capability-gated). */
export class StaffFinanceViewModel extends ViewModel {
    client;
    constructor(client) {
        super({ summary: null, investors: [], loading: false, error: null });
        this.client = client;
    }
    canReadBusiness() {
        const role = this.client.claims()?.role ?? "";
        return roleHasDealershipCapability(role, "business:read");
    }
    canWriteBusiness() {
        const role = this.client.claims()?.role ?? "";
        return roleHasDealershipCapability(role, "business:write");
    }
    canManageInvestors() {
        const role = this.client.claims()?.role ?? "";
        return roleHasDealershipCapability(role, "investors:manage");
    }
    async load() {
        if (!this.canReadBusiness() && !this.canManageInvestors()) {
            this.setState({ summary: null, investors: [], error: null });
            return;
        }
        await this.run(async () => {
            const summary = this.canReadBusiness() ? await this.client.businessSummary() : null;
            const investors = this.canManageInvestors() ? await this.client.listInvestors() : [];
            this.setState({ summary, investors });
        }, "Failed to load finance data.");
    }
    async recordSale(input) {
        if (!this.canWriteBusiness())
            return false;
        const ok = await this.run(async () => {
            await this.client.recordSale(input);
            await this.load();
            return true;
        }, "Failed to record sale.");
        return ok === true;
    }
    async recordExpense(input) {
        if (!this.canWriteBusiness())
            return false;
        const ok = await this.run(async () => {
            await this.client.recordExpense(input);
            await this.load();
            return true;
        }, "Failed to record expense.");
        return ok === true;
    }
}
//# sourceMappingURL=StaffFinanceViewModel.js.map